import {useSearchParams} from 'react-router-dom';
import {OccasionBrandType} from '../../../gql/pwa/graphql';
import {useCallback, useMemo} from 'react';
import {SingleValue} from 'react-select';

export interface BrandOption {
    value: string | null | undefined;
    label: string | null | undefined;
    meta: OccasionBrandType;
}
export function useBrands(occasionBrands: Array<OccasionBrandType | null> | null | undefined, brands?: string[]) {
    const occasionBrandOptions: BrandOption[] = useMemo(() => {
        return (
            occasionBrands
                ?.filter((b): b is NonNullable<typeof b> => b != null)
                .map((b) => {
                    return {
                        value: b.name,
                        label: b.name,
                        meta: b,
                    };
                }) ?? []
        );
    }, [occasionBrands]);
    const selectedOccasionBrandOption: BrandOption | null = useMemo(
        () => occasionBrandOptions?.find((obo) => obo.value === brands?.[0]) ?? null,
        [occasionBrandOptions, brands],
    );

    const [, setSearchParams] = useSearchParams();
    const onSetBrandsCallback = useCallback(
        (value: SingleValue<BrandOption>) => {
            setSearchParams((current) => {
                if (value?.value) {
                    current.set('brands', value.value);
                } else {
                    current.delete('brands');
                }
                current.delete('models');
                current.delete('page');
                return current;
            });
        },
        [setSearchParams],
    );

    return {
        occasionBrandOptions,
        selectedOccasionBrandOption,
        onSetBrandsCallback,
    };
}
